import { render, staticRenderFns } from "./ConsorcioCohab9Form.vue?vue&type=template&id=ad5c81a8&"
import script from "./ConsorcioCohab9Form.vue?vue&type=script&lang=js&"
export * from "./ConsorcioCohab9Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports